import { inject, Injectable } from '@angular/core';
import { Messaging, getToken, onMessage } from '@angular/fire/messaging';
import { Firestore, doc, setDoc, arrayUnion } from '@angular/fire/firestore';
import { Auth } from '@angular/fire/auth';
import { environment } from '../../../environments/environment';
import { BehaviorSubject } from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class PushNotificationService {
    private messaging = inject(Messaging);
    private firestore = inject(Firestore);
    private auth = inject(Auth);

    private tokenSubject = new BehaviorSubject<string | null>(null);
    token$ = this.tokenSubject.asObservable();

    constructor() { }

    async requestPermission() {
        if (!('Notification' in window)) {
            console.warn('Notifications not supported in this browser.');
            return;
        }

        try {
            const permission = await Notification.requestPermission();
            if (permission === 'granted') {
                await this.saveToken();
            }
        } catch (err) {
            console.error('Permission request failed', err);
        }
    }

    private async saveToken() {
        const u = this.auth.currentUser;
        if (!u) return;

        try {
            const token = await getToken(this.messaging, { vapidKey: (environment as any).vapidKey });
            if (token) {
                this.tokenSubject.next(token);
                // Atomically add to fcmTokens array in Firestore
                const userRef = doc(this.firestore, `users/${u.uid}`);
                await setDoc(userRef, {
                    fcmTokens: arrayUnion(token)
                }, { merge: true });
            }
        } catch (err) {
            console.error('Getting FCM token failed', err);
        }
    }

    listenForMessages() {
        onMessage(this.messaging, (payload) => {
            console.log('Foreground message received:', payload);
            // This is handled by a standard in-app notification logic if needed
        });
    }
}
